import { Download } from "lucide-react";

export function Footer({ onExport }: { onExport?: () => void }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 border-t border-[#DED8CC] px-1 pb-1 pt-4">
      <span className="text-[13px] text-[#687368]">
        Data from EverTutor continuous assessment. Updated daily. On Track to
        Proficiency refreshed monthly.
      </span>
      <button
        onClick={onExport}
        className="flex cursor-pointer items-center gap-2 rounded-[6px] border-none bg-[#28543D] hover:bg-[#204833] px-[18px] py-2.5 text-sm font-bold text-white"
      >
        <Download size={16} strokeWidth={2.2} />
        Download CSV
      </button>
    </div>
  );
}
